module.exports = __webpack_public_path__ + "static/img/submit-btn.0ee19ccf.png";